import { render, staticRenderFns } from "./IxImageLayer.vue?vue&type=template&id=f1cf7566&scoped=true&"
import script from "./IxImageLayer.vue?vue&type=script&lang=js&"
export * from "./IxImageLayer.vue?vue&type=script&lang=js&"
import style0 from "./IxImageLayer.vue?vue&type=style&index=0&id=f1cf7566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cf7566",
  null
  
)

export default component.exports